import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function CancelShiftHeader(): JSX.Element {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        paddingTop: 12,
        paddingBottom: 6,
        paddingX: 6,
        background:
          "linear-gradient(180deg, rgba(250, 248, 247, 0.00) 0%, #FFF 72.7%), linear-gradient(117deg, #F6F3F1 18.83%, rgba(249, 225, 225, 0.84) 96.06%)",
      }}
    >
      <Text
        variant="h2"
        color={(theme) => theme.palette.intent?.error.text}
        sx={{ textAlign: "center" }}
      >
        Cancel your shift?
      </Text>
      <Text
        variant="h6"
        color={(theme) => theme.palette.text.secondary}
        sx={{ textAlign: "center" }}
      >
        How this will impact your Clipboard Score
      </Text>
    </Stack>
  );
}
